export const UPDATE_EXPERIMENTS = 'UPDATE_EXPERIMENTS';

export const updateExperiments = data => {
  return {
    type: UPDATE_EXPERIMENTS,
    data,
  };
};



// WEBPACK FOOTER //
// ./src/actions/experimentActions.js